import React from 'react';
import axios from 'axios';
import { findDOMNode, unmountComponentAtNode } from 'react-dom';
import LoginForm from './Form';
import ResetForm from '../passwordReset/ResetForm';
import InactiveBg from '../components/InactiveBg';
import { TransitionGroupMode, TransitionItem } from '../components/transitions/Slide';

export default class CampaignCreator extends React.Component {
  state = {
    showForm: 'login',
    formHeight: 'auto',
    wentBack: false,
  };

  cmp = {};

  componentDidMount() {
    this.updateHeight();
    window.addEventListener('resize', this.updateHeight);
  }

  componentDidUpdate() {
    this.updateHeight();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateHeight);
  }

  updateHeight = () => {
    // eslint-disable-next-line react/no-find-dom-node
    const el = findDOMNode(this.cmp[this.state.showForm]);

    if (!el) return;

    const newHeight = el.querySelector('.a-slide__height').clientHeight;

    if (this.state.formHeight !== newHeight) {
      this.setState({
        formHeight: newHeight
      });
    }
  };

  login = (e, formData) => {
    e.preventDefault();

    formData.action = 'login';
    document.getElementById('loading').style.display = "block";
    axios.post('/p2p/prihlasenie/', formData).then((response) => {
      window.location.href = '/p2p/moje/';
    }).catch((error) => {
      document.getElementById('loading').style.display = "none";
      app.features.notification('.js-notification', {
        text: error.response.data.errors,
        status: 'error'
      });
    });
  };

  resetPassword = (e, formData) => {
    e.preventDefault();
    document.getElementById('loading').style.display = "block";
    axios.post('/p2p/prihlasenie/', formData).then((response) => {
      app.features.notification('.js-notification', {
        text: 'XXXX',
        status: 'success'
      });
    }).catch((error) => {
      document.getElementById('loading').style.display = "none";
      app.features.notification('.js-notification', {
        text: 'YYY',
        status: 'success'
      });
    });
  };

  showForgotPassword = (e) => {
    e.preventDefault();
    this.setState({ showForm: 'reset', wentBack: false });
  };

  showLogin = (e) => {
    e.preventDefault();
    this.setState({ showForm: 'login', wentBack: true });
  };

  onCancel = () => {
    // eslint-disable-next-line react/no-find-dom-node
    const thisNode = findDOMNode(this);
    unmountComponentAtNode(thisNode.parentNode);
  };

  render() {
    const { showForm, wentBack, formHeight: height } = this.state;
    const { initProps: { asPage } = {} } = this.props;

    let Form;

    switch (showForm) {
      case 'login':
        Form = (
          <TransitionItem key={1} ref={c => { this.cmp.login = c; }}>
            {!asPage && <div style={{ height: '4rem' }} />}
            <LoginForm onSubmit={this.login} onForgot={this.showForgotPassword}
                       langSwitcher={asPage} displaySocialLogin={true} />
          </TransitionItem>
        );
        break;
      default:
        Form = (
          <TransitionItem key={2} ref={c => { this.cmp.reset = c; }}>
            {!asPage && <div style={{ height: '4rem' }} />}
            <ResetForm onSubmit={this.resetPassword} onCancel={this.showLogin} />
          </TransitionItem>
        );
    }

    const AnimatedGroup = (
      <TransitionGroupMode height={height + 40 /* lol */} mode="quarter" reversed={wentBack}>
        {Form}
      </TransitionGroupMode>
    );

    return asPage
      ? AnimatedGroup
      : <InactiveBg onClose={this.onCancel}>
          {AnimatedGroup}
        </InactiveBg>;
  }
}



// WEBPACK FOOTER //
// ./app/Assets/js/features/login/index.js